module.exports = __webpack_public_path__ + "static/giveaway-409f1da188a8e9cfd9a4980a6db00b21.svg";